/* eslint-disable camelcase */
type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_be_first_to_hear_about_exclusive_offers: Phrase = locale => {
  const en = `Be the first to hear about exclusive offers.`;
  const phrases: { [key: string]: undefined | string } = {
    en,
    es: `Sé el primero en saber sobre nuestras ofertas exclusivas.`,
  };
  return phrases[locale] || en;
};
